import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const Ignoring = () => {
  const ignoringPdf = pdfFiles.strategiesPart2.find(
    (pdf) => pdf.name === 'Common Questions About Ignoring',
  );

  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter pdfFile={ignoringPdf} vidSrc={1194426085} />
    </div>
  );
};

export default Ignoring;
